import React, { useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FileUploader } from 'react-drag-drop-files';

import ProgressBar from './progress-bar.js';
import useUploadFile from '../../hooks/useUploadFile.js';
import { FilesUploader, FileUploaderContainer, Blip, UploadedFile } from './style.js';

const themes = {
  light: {
    text: '#363537',
    background: '#FFF',
    borderColor: '#000',
  },
  dark: {
    text: '#FAFAFA',
    background: '#000',
    borderColor: '#FAFAFA',
  },
};

const cfUrl = process.env.REACT_APP_CF_URL;
const appName = process.env.REACT_APP_APP_NAME;
export const functionURL = 'https://rlzu6cfhrqlvhfrn2krp7sefkm0hawwy.lambda-url.us-east-1.on.aws/';

const FilesUploader_ = ({ form, field, options }) => {
  const { t } = useTranslation();
  const { maxFiles, maxSize, format } = options;
  const fileTypes = format || [];
  const multipleFiles = maxFiles && maxFiles > 1;

  const [files, setFiles] = useState([]);
  const [filesNumber, setFilesNumber] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const { progress, uploadFile } = useUploadFile();

  const handleChange = (newFiles) => {
    setShowProgress(true);
    uploadFiles(multipleFiles ? [...newFiles] : [newFiles]).then((filesURLs) => {
      form.setFieldValue(field.name, filesURLs);
      form.setFieldTouched(field.name, true, false);
    });
  };

  /**
   *
   * @param {Array<object>} files list of files to upload
   * @returns {Promise<Array<string>>} filesURLs list of URLs
   */
  const uploadFiles = async (files) => {
    const filesURLs = [];
    setFilesNumber(files.length);

    for await (const file of files) {
      const searchParams = `?key=${file.name}&contentType=${file.type}&app=${appName}`;
      let signedUrlResponse = await axios.get(functionURL + searchParams);
      const { signedUrl, fileKey } = signedUrlResponse.data;
      const url = encodeURI(cfUrl + fileKey);
      await uploadFile(signedUrl, file, file.type);
      setFiles((prev) => (multipleFiles ? [...prev, file] : [file]));
      filesURLs.push(url);
    }
    return filesURLs;
  };

  const setError = () => {
    const text = 'Max 10 Mb!';
    form.setFieldTouched(field.name, true, false);
    form.setFieldError(field.name, text);
  };

  return (
    <FilesUploader>
      <div style={{ width: '350px' }}>
        <FileUploader
          name="file"
          multiple={multipleFiles}
          types={fileTypes}
          onTypeError={(e) => setError(e)}
          hoverTitle=" "
          maxSize={maxSize || 20}
          onSizeError={(e) => setError(e)}
          handleChange={handleChange}
        >
          <FileUploaderContainer theme={themes.dark}>
            <p>{t('File_Uploader_T4')}</p>
          </FileUploaderContainer>
        </FileUploader>
      </div>
      {showProgress ? (
        <ProgressBar progress={progress} filesNumber={filesNumber} filesUploaded={files.length} />
      ) : null}
      {files.map((file) => (
        <UploadedFile key={file.name} id={field.name}>
          <Blip />
          {file.name} {Math.round(file.size / 1000)}kb
        </UploadedFile>
      ))}
    </FilesUploader>
  );
};

export default FilesUploader_;

FilesUploader_.propTypes = {
  form: PropTypes.object,
  field: PropTypes.object,
  options: PropTypes.object,
};
